import { render, staticRenderFns } from "./InnerPage.vue?vue&type=template&id=02738d1d&scoped=true&"
import script from "./InnerPage.vue?vue&type=script&lang=js&"
export * from "./InnerPage.vue?vue&type=script&lang=js&"
import style0 from "./InnerPage.vue?vue&type=style&index=0&id=02738d1d&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02738d1d",
  null
  
)

export default component.exports